import { action, makeAutoObservable } from 'mobx';
import { RouterBackoffice } from 'src/AppState/RouterBackoffice';
import { EventsTabPropsType } from 'src/components/CustomersBar/EventsTab/EventsTab';

export class EventsTabState {
    constructor(
        readonly props: EventsTabPropsType,
        readonly routerBackoffice: RouterBackoffice
    ) {
        makeAutoObservable(this);
    }

    @action redirectToSearchEvent = (eventId: number): void => {
        const userId = this.props.id;
        this.routerBackoffice.redirectToTelebetSearchEvent(userId, eventId);
    };
}
